<template>
  <div class="task_box ma-lg round-12 bg-all-light">
    <div class="task_box_head mb-md">
      <wd-img class="task_box_head-img" :src="taskHeadTitle"/>
      <span class="task_box_head-title">活动任务</span>
    </div>
    <div class="task_list pa-lg">
      <upload-photo/>
      <upload-file/>
      <upload-video/>
      <upload-music/>
    </div>
  </div>
</template>

<script>
import UploadPhoto from "@/views/lotto/components/Task/UploadPhoto";
import UploadFile from "@/views/lotto/components/Task/UploadFile";
import UploadVideo from "@/views/lotto/components/Task/UploadVideo";
import UploadMusic from "@/views/lotto/components/Task/UploadMusic";
import {taskHeadTitle} from "@/skin/skin";

export default {
  name: "Task",
  data(){
    return{
      taskHeadTitle: taskHeadTitle
    }
  },
  components: {
    UploadPhoto,
    UploadFile,
    UploadVideo,
    UploadMusic,
  }
}
</script>

<style lang="scss">

.task_box {
  border: 1px #f49d9d solid;
  background-color: #fff;

  .task_list {

    .task_item {
      color: white;
      font-size: 12px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-evenly;
      .item_title {
        font-family: FZCuHeiSongS-B-GB, serif;
        padding: 0 12px;
        display: inline-block;
        background-color: white;
        font-size: 12px;
        border-bottom-right-radius: 16px;
        border-bottom-left-radius: 16px;
      }

      .right{
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 80px ;
      }
      .center {
        width: fit-content;
      }
      .left {
        align-self: center;
      }

      .item-action {
        width: 70px !important;
        box-shadow: none !important;
        padding: 0 8px 1px 8px;
        margin: 0;
        height: auto;
        font-size: 12px;
        min-width: auto;
      }
    }
  }

  .task_box_head {
    text-align: center;

    .task_box_head-img {
      position: absolute;
      width: 48px;
      margin-top: -8px;
      margin-left: -8px;
    }

    .task_box_head-title {
      display: inline-block;
      padding: 2px 40px 2px 48px;
      background-color: #f49d9d;
      color: white;
      border-bottom-right-radius: 24px;
      border-bottom-left-radius: 24px;
      font-size: 18px;
      font-weight: 900;
      letter-spacing: 8px
    }
  }
}
</style>
